import { ReactElement, ReactNode } from 'react'
import { Typography } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

export interface EmptyStateProps {
  icon: ReactElement
  title: ReactNode
  titleVariant?: 'h5' | 'h6'
  titleColor?: string
  subtitle?: ReactNode
  subtitleVariant?: 'body1' | 'body2'
  subtitleColor?: string
  subtitleSx?: SxProps<Theme>
  action?: ReactNode
}

// Deliberately content-only (no wrapping Box/Card/TableCell) - every call
// site keeps its own existing wrapper (Card>CardContent, bare Box, or
// TableRow>TableCell>Box) so the surrounding layout/padding is untouched.
const EmptyState = ({
  icon,
  title,
  titleVariant = 'h6',
  titleColor,
  subtitle,
  subtitleVariant = 'body2',
  subtitleColor,
  subtitleSx,
  action,
}: EmptyStateProps) => (
  <>
    {icon}
    <Typography variant={titleVariant} color={titleColor} gutterBottom>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant={subtitleVariant} color={subtitleColor} sx={subtitleSx}>
        {subtitle}
      </Typography>
    )}
    {action}
  </>
)

export default EmptyState
